module.exports = __webpack_public_path__ + "img/telegram-white.d709a581.svg";